module.exports = __webpack_public_path__ + "static/img/image2_jc.84c16434.jpg";